/**
 * Frontend environment configuration.
 * Values that are safe for client-side exposure.
 */

function requireEnv(key: string): string {
  const value = import.meta.env[key];
  if (!value) {
    // In development, warn; in production builds, this is a hard failure
    if (import.meta.env.DEV) {
      console.warn(`[ENV] Missing required environment variable: ${key}. Using empty string fallback.`);
      return '';
    }
    throw new Error(`[ENV] Missing required environment variable: ${key}. Check your .env file or deployment configuration.`);
  }
  return value;
}

export const ENV = {
  firebase: {
    apiKey: requireEnv('VITE_FIREBASE_API_KEY'),
    authDomain: requireEnv('VITE_FIREBASE_AUTH_DOMAIN'),
    projectId: requireEnv('VITE_FIREBASE_PROJECT_ID'),
    storageBucket: requireEnv('VITE_FIREBASE_STORAGE_BUCKET'),
    messagingSenderId: requireEnv('VITE_FIREBASE_MESSAGING_SENDER_ID'),
    appId: requireEnv('VITE_FIREBASE_APP_ID'),
  },

  recaptchaSiteKey: requireEnv('VITE_RECAPTCHA_SITE_KEY'),
  paystackPublicKey: requireEnv('VITE_PAYSTACK_PUBLIC_KEY'),

  /**
   * Subscription plans — MUST match functions/src/config/env.ts SUBSCRIPTION_PLANS.
   * Amounts in kobo (1 NGN = 100 kobo).
   * Update both files together when changing plan definitions.
   */
  plans: {
    '1month': { label: '1 Month VIP', amountNaira: 5000, amountKobo: 500000, days: 30 },
    '3months': { label: '3 Months VIP', amountNaira: 12500, amountKobo: 1250000, days: 90 },
    '6months': { label: '6 Months VIP', amountNaira: 20000, amountKobo: 2000000, days: 180 },
  },

  pageSize: 12,
} as const;
